"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeContentScrollingHack = void 0;
const removeContentScrollingHack = () => {
    // Because of the hack added to remove page scroll in the old version in the App.tsx
    // file, need to access the DOM for removing its class.
    const contentScrollingHackSibling = 'content-scrolling-hack-sibling';
    const scrollingHackItems = document.getElementsByClassName(contentScrollingHackSibling);
    if (scrollingHackItems?.length > 0) {
        scrollingHackItems[0].classList.remove(contentScrollingHackSibling);
    }
};
exports.removeContentScrollingHack = removeContentScrollingHack;
